import { Flags } from '@anyroad/flags';
import { sendEventToSegment } from 'views/anyguide/helpers/analytics/segmentHelpers';
import { getSessionId } from 'views/plugins/tours/page/booking_details/Helpers';

function safeSessionStorageGet(key) {
  try {
    return window?.sessionStorage?.getItem(key);
  } catch (error) {
    return undefined;
  }
}

function safeSessionStorageSet(key, value) {
  try {
    return window?.sessionStorage?.setItem(key, value);
  } catch (error) {
    return undefined;
  }
}

export function trackCheckoutMobileArriveOnPage({
  flags,
  bookingRequestId,
  tourId,
  guideId,
  guideName,
  pageName,
}) {
  if (!bookingRequestId) return;
  if (!tourId) return;
  if (!flags?.[Flags['event-tracking-checkout-02112026-enabled']]) return;

  const storageKey = `segment:checkout:legacy_mobile:${bookingRequestId}:${pageName}`;
  if (safeSessionStorageGet(storageKey) === '1') return;

  try {
    sendEventToSegment('Arrive on page', {
      path: window.location.hash || window.location.pathname,
      referrer: document.referrer,
      session_id: getSessionId(),
      page_name: pageName,
      url: window.location.href,
      checkout_flow: 'legacy_mobile',
      experience_id: tourId,
      account_id: guideId,
      account_name: guideName,
      device: 'mobile',
    });
    safeSessionStorageSet(storageKey, '1');
  } catch (error) {
    console.log('segment tracking error', error);
  }
}
